import useAuditLog from '../../io/useAuditLog'
import AuditLogTable from './AuditLogTable'

type Props = {
  targetId: string
}

const AuditHistoryTab = ({ targetId }: Props) => {
  const { entries, loadMore, hasMore, loading, error } = useAuditLog({ targetId })
  return <AuditLogTable entries={entries} loading={loading} error={error} hasMore={hasMore} loadMore={loadMore} />
}

export default AuditHistoryTab
